// Only translated, known errors are shown to operators. Keep raw service errors in logs.
const CODE_KEYS = {
  CUSTOMER_EMAIL_REQUIRED: "feedback.customerEmail",
  LOCATION_COORDINATES_REQUIRED: "placeForm.coordinates",
  LOCATION_COORDINATES_INVALID: "placeForm.coordinates",
  LOCATION_ADDRESS_REQUIRED: "placeForm.address",
  PARTNER_NOT_FOUND: "feedback.recordMissing",
  LOCATION_NOT_FOUND: "feedback.recordMissing",
  PLACE_NOT_FOUND: "feedback.recordMissing",
  PLACE_REQUIRED: "placeForm.coordinates",
  MISSING_FLEET_LOCATION: "toast.missingFleetLocation",
  ORDER_TYPE_NOT_ALLOWED: "feedback.transportType",
  FLEET_PLAN_REQUIRED: "feedback.plan",
  INVALID_PARTNER_LOCATION: "feedback.recordUnavailable",
  LOCATION_REQUIRED_BY_CUSTOMER: "feedback.placeInUse",
};
const MESSAGE_KEYS = {
  "Partner name is required": "feedback.contactName",
  "Location name is required": "feedback.contactName",
  "At least one partner role is required": "feedback.contactRole",
  "At least one location role is required": "feedback.placeRole",
  "Selected directory record is unavailable for this role": "feedback.recordUnavailable",
  "Selected place is unavailable for this checkpoint": "feedback.recordUnavailable",
  "The shared record needs more information before it can be saved": "validationReviewFields",
  "Only active drafts can be reprocessed": "orderImport.staleDraft",
  "Only active drafts can be resolved": "orderImport.staleDraft",
  "existingFinalized": "orderImport.existingFinalized",
  "existingEditable": "orderImport.existingEditable",
  "multipleExisting": "orderImport.multipleExisting",
  "staleDraft": "orderImport.staleDraft",
};

export function fleetErrorMessage(t, error, fallback, values = {}) {
  const data = error?.response?.data || error?.details || {};
  const code = String(data.code || error?.code || "");
  const message = String(data.message || error?.message || "");
  const keys = [CODE_KEYS[code], data.messageKey, error?.messageKey, MESSAGE_KEYS[message]];
  for (const key of keys) {
    if (!key || typeof key !== "string") continue;
    const params = data.messageParams || error?.messageParams || {};
    const field = typeof params.fieldKey === 'string' && params.fieldKey.startsWith('orderDetail.') ? t(params.fieldKey) : '';
    const translated = t(key, { row: params.row, field, ...values, defaultValue: "" });
    if (typeof translated === "string" && translated && translated !== key) return translated;
  }
  const status = error?.response?.status;
  let key;
  if (status === 401 || /^(?:functions\/unauthenticated|auth\/user-token-expired|auth\/requires-recent-login)$/.test(code)) key = "feedback.session";
  else if (status === 403 || /(?:permission-denied|unauthorized)$/.test(code)) key = "feedback.permission";
  else if (status === 402) key = "feedback.plan";
  else if (status === 404 || /(?:^|\/)not-found$/.test(code)) key = "feedback.recordMissing";
  else if (status === 409 || /(?:aborted|already-exists)$/.test(code)) key = "feedback.conflict";
  else if (status === 429 || /resource-exhausted$/.test(code)) key = "feedback.rateLimit";
  else if (["ECONNABORTED", "ETIMEDOUT"].includes(code) || /deadline-exceeded$/.test(code)) key = "feedback.timeout";
  else if (code === "ERR_NETWORK" || /network-request-failed$/.test(code)) key = "feedback.network";
  else if (status >= 500 || /(?:^|\/)(?:internal|unavailable)$/.test(code)) key = "feedback.unavailable";
  else if (error?.errorFields?.length) key = "validationReviewFields";
  return key ? t(key) : fallback;
}

export function fleetToastContent(t, { title, description, error, reference }) {
  const reason = error ? fleetErrorMessage(t, error, description) : description;
  const message = title || reason || t("feedback.unavailable");
  const details = [reference ? t("feedback.reference", { reference }) : null, reason !== message ? reason : null].filter(Boolean);
  return { message, description: details.length ? details.join("\n") : undefined };
}
